import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

var EventBus =
/*#__PURE__*/
function () {
  function EventBus() {
    _classCallCheck(this, EventBus);

    this.subject$ = new Subject();
  }

  _createClass(EventBus, [{
    key: "emit",
    value: function emit(event) {
      this.subject$.next(event);
    }
  }, {
    key: "on",
    value: function on(eventName, action) {
      return this.subject$.pipe(filter(function (e) {
        return e.name === eventName;
      }), map(function (e) {
        return e['value'];
      })).subscribe(action);
    }
  }]);

  return EventBus;
}();

if (!window['EventBusService']) {
  window['EventBusService'] = new EventBus();
}

export var EventBusService = window['EventBusService'];
export var EventData = function EventData(name, value) {
  _classCallCheck(this, EventData);

  this.name = name;
  this.value = value;
};